<template>
  <q-dialog v-model="_show" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="alert" color="primary" text-color="white" />
        <span class="q-ml-sm">Confirma exclusão de tema?</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancelar" color="primary" v-close-popup />
        <q-btn
          flat
          label="Confirmar"
          color="primary"
          @click="confirmDeletion(id)"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  setup() {},
  props: { show: Boolean, id: String },
  emits: ["confirmDeletion", "update:show"],
  computed: {
    _show: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit("update:show", v);
      }
    }
  },
  methods: {
    confirmDeletion(id) {
      this.$emit("confirmDeletion", id);
    }
  }
};
</script>
